import { parseAuthToken } from 'utils/api'

export const FILTERED_CLIENT_IDS = [
  '1f4a2b9e-6d3f-4c8a-9b2f-2f7c3e9d8a01',
  '7c9e6679-7425-40de-944b-e07fc1f90ae7',
  'd290f1ee-6c54-4b01-90e6-d701748f0851',
  '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  '9b0f3a2c-4d1e-4f9a-8b7d-5f3c2a1e6b90',
  'a3f1d2e4-8b7c-4f6a-9d5e-2a1b3c4d5e6f',
  '4e1a2b3c-5d6f-47a8-9b0c-1d2e3f4a5b6c',
  '12b0e41b-3102-40a9-9651-10865d374fbe',
  'b7c6d5e4-f3a2-4b1c-8d9e-0f1a2b3c4d5e',
  '0d9c8b7a-6e5f-4d3c-9b2a-1f0e2d3c4b5a',
  'e2f3d4c5-b6a7-48c9-8d0e-1f2a3b4c5d6e',
  'f1e2d3c4-b5a6-47c8-9d0f-1a2b3c4d5e6f',
  'c3b2a1d0-9e8f-4c7b-8a6d-5e4f3c2b1a0d',
  '6a5b4c3d-2e1f-48a9-8b7c-0d1e2f3a4b5c',
  '8d7c6b5a-4e3f-49b8-9a0c-1b2d3e4f5a6b',
  '9d19385b-ff9a-450d-915b-cfeea8458f83',
  '2b3c4d5e-6f7a-48b9-8c1d-0e2f3a4b5c6d',
  '5f4e3d2c-1b0a-47c8-9d6e-2f3a4b5c6d7e',
  '3d4c5b6a-7e8f-49a8-9b0c-1d2e3f4a5b6c',
  'a7b6c5d4-e3f2-48b9-8c1d-0e2f3a4b5c6d',
  '9e8d7c6b-5a4f-47c8-9d0e-1f2a3b4c5d6e',
  '0a1b2c3d-4e5f-46a9-8b7c-1d2e3f4a5b6c',
  'b1c2d3e4-f5a6-47b8-9c0d-1e2f3a4b5c6d',
  'd4c3b2a1-0f9e-48c7-8b6a-5d4e3f2a1b0c',
  '7a6b5c4d-3e2f-49a8-9b0c-1d2e3f4a5b6c',
  '4c3b2a1d-0e9f-47b8-9c6a-5f4e3d2c1b0a',
  'e6f5d4c3-b2a1-48c9-8d0e-1f2a3b4c5d6e',
  'c6b5a4d3-2e1f-49b8-9a0c-1d2e3f4a5b6c',
  '1a2b3c4d-5e6f-47a8-9b0c-1d2e3f4a5b6c',
  '8b9c0d1e-2f3a-48b7-9c6d-5e4f3a2b1c0d',
]

// 6527a612-9eef-465e-848d-a448febfe70c Tim Fimmers
// 534fff25-2aeb-4cac-a61b-7e8a9d7377de João Britto
// 531c1843-373a-4072-b9ab-4ce87983bcfc Cam Cook
// 2448c38a-5800-4a95-8b86-589a9cf4efdc Caique Mitsuoka
// b4db87f7-7ca5-4683-be89-4e895893cf30 Howard Chang
export const ALLOWED_SEAT_IDS = [
  'd7dfbd73-a5fc-4aa0-b0b7-6ce6c086140e',
  '5eb77f4c-e509-4adc-b973-1b297216ff69',
  '6527a612-9eef-465e-848d-a448febfe70c',
  '534fff25-2aeb-4cac-a61b-7e8a9d7377de',
  '531c1843-373a-4072-b9ab-4ce87983bcfc',
  '2448c38a-5800-4a95-8b86-589a9cf4efdc',
  'b4db87f7-7ca5-4683-be89-4e895893cf30',
]

export function isClientFiltered(clientId: string): boolean {
  if (!FILTERED_CLIENT_IDS.includes(clientId)) return false
  const { sub } = parseAuthToken()
  return !ALLOWED_SEAT_IDS.includes(sub ?? '')
}
